import { axiosInstance } from '@/lib/axios'
import {
  WebfleetBorderConfirmRequest,
  WebfleetBorderConfirmResponse,
} from './types'

type Props = {
  companyId: string
  payload: WebfleetBorderConfirmRequest
}

export function confirmWebfleetBorders({ companyId, payload }: Props) {
  return axiosInstance.post<WebfleetBorderConfirmResponse>(
    `/api/${companyId}/webfleet/borders/confirm`,
    payload,
  )
}
